import {
	AfterViewInit,
	Component,
	ElementRef,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { PopoverManager } from '@components/popover_manager.component';
import { createRoot, Root } from 'react-dom/client';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'reactPopoverManagerComponent';

@Component({
	standalone: false,
	selector: 'popover-manager-component',
	template: `<div class="wrapper-container popover" #${containerElementName}></div>`,
	encapsulation: ViewEncapsulation.None,
})
export class PopoverManagerComponent implements OnChanges, OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	ngOnChanges(_: SimpleChanges): void {
		this.render();
	}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private async render() {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		root.render(
			<CellulaProviderWrapper>
				<PopoverManager />
			</CellulaProviderWrapper>,
		);
	}
}
